export default "__VITE_ASSET__DpYN3VGX__"